document.addEventListener('DOMContentLoaded', function() {
  var carousel = document.getElementById('testimonial-carousel');
  if (!carousel) return;
  var slides = carousel.querySelectorAll('.testimonial-slide');
  var prevBtn = document.getElementById('testimonial-prev');
  var nextBtn = document.getElementById('testimonial-next');
  var current = 0;
  var autoplayInterval = null;
  var AUTOPLAY_DELAY = 5000;

  function showSlide(idx) {
    slides.forEach(function(slide, i) {
      slide.style.display = (i === idx) ? 'flex' : 'none';
    });
  }

  function nextSlide() {
    current = (current + 1) % slides.length;
    showSlide(current);
  }

  function prevSlide() {
    current = (current - 1 + slides.length) % slides.length;
    showSlide(current);
  }

  function startAutoplay() {
    if (autoplayInterval) clearInterval(autoplayInterval);
    autoplayInterval = setInterval(nextSlide, AUTOPLAY_DELAY);
  }

  function stopAutoplay() {
    if (autoplayInterval) clearInterval(autoplayInterval);
    autoplayInterval = null;
  }

  prevBtn.addEventListener('click', function() {
    prevSlide();
    stopAutoplay();
    setTimeout(startAutoplay, AUTOPLAY_DELAY);
  });
  nextBtn.addEventListener('click', function() {
    nextSlide();
    stopAutoplay();
    setTimeout(startAutoplay, AUTOPLAY_DELAY);
  });

  // Optional: swipe support for mobile
  var startX = null;
  carousel.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
  });
  carousel.addEventListener('touchend', function(e) {
    if (startX === null) return;
    var endX = e.changedTouches[0].clientX;
    if (endX - startX > 50) {
      prevSlide();
      stopAutoplay();
      setTimeout(startAutoplay, AUTOPLAY_DELAY);
    }
    else if (startX - endX > 50) {
      nextSlide();
      stopAutoplay();
      setTimeout(startAutoplay, AUTOPLAY_DELAY);
    }
    startX = null;
  });

  // Show the first slide initially
  showSlide(current);
  startAutoplay();
}); 